<template>
    <div>

        <a href="#" class="block pb-2 text-3xl text-gray-600 cursor-pointer md:pb-8 hover:text-gray-700 focus:text-gray-700" @click="toggle">
            <svg class="h-4 w-auto text-brand-lime" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="6.5" y1="0.5" x2="23.5" y2="0.5" stroke="#CFFC82" stroke-linecap="round"></line><line x1="0.5" y1="7.5" x2="23.5" y2="7.5" stroke="#CFFC82" stroke-linecap="round"></line><line x1="0.5" y1="14.5" x2="17.5" y2="14.5" stroke="#CFFC82" stroke-linecap="round"></line></svg>
            <span class="sr-only"> Toggle Menu</span></a>

        <div v-show="open" class="fixed inset-0 z-20 overflow-hidden">
            <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0 transition-opacity duration-500 bg-gray-800 bg-opacity-75" :class="{ 'opacity-0': !opening, 'opacity-100': opening }" aria-hidden="true"></div>

                <section class="absolute inset-y-0 right-0 flex max-w-full pl-10" aria-labelledby="slide-over-heading">
                    <div class="relative w-screen max-w-md transition duration-500 sm:duration-700" :class="{ 'translate-x-full': !opening, 'translate-x-0': opening }">
                        <div class="absolute top-0 left-0 flex pt-4 pr-2 -ml-8 duration-500 sm:-ml-10 sm:pr-4" :class="{ 'opacity-0': !opening, 'opacity-100': opening }">
                            <button class="text-gray-300 rounded-md hover:text-white focus:outline-none focus:ring-2 focus:ring-white" @click="toggle">
                                <span class="sr-only">Close panel</span>
                                <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div class="flex flex-col h-full py-6 overflow-y-scroll bg-white shadow-xl">
                            <div class="relative flex-1 px-4 mt-6 sm:px-6">
                                <slot :hideMenu="toggle"></slot>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>

    </div>
</template>

<script>
    export default {

        data() {
            return {
                open: false,
                opening: false,
            }
        },

        methods: {
            toggle() {
                if (this.open) {
                    this.opening = false;
                    setTimeout( () => this.open = false, 700);
                    return;
                }

                this.open = true;
                setTimeout(() => this.opening = true, 1);
            },
        }
    }
</script>
